import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import VideoPlayer from 'vue-video-player'


const app = createApp(App)

app.use(ElementPlus)
app.use(VideoPlayer)
app.use(store).use(router).mount('#app')
app.use(ElementPlus, {
  locale: zhCn,
})
